import { LO_STO } from '../../lib'
import loSto from '../../config/loSto'
import moment from 'moment'

const defaults = {
  scheduleDate: {
    __typename: 'ScheduleDate',
    date: loSto.get(LO_STO.SCHEDULE_DATE) || moment().format()
  },
  shouldUpdateSchedule: null
}

const resolvers = {
  Mutation: {
    updateScheduleDate: (_, { date }, { cache }) => {
      const data = {
        scheduleDate: {
          __typename: 'ScheduleDate',
          date
        }
      }
      cache.writeData({ data })
      return null
    },
    setUpdateSchedule: (_, unused, { cache }) => {
      const flag = cache.data.data.ROOT_QUERY.shouldUpdateSchedule
      const data = {
        shouldUpdateSchedule: flag ? !flag : true
      }
      cache.writeData({ data })
      return null
    }
  }
}

export default { defaults, resolvers }
